// extracted by css-extract-rspack-plugin
export default {"backButton":"nav-back-arrow-button-module__backButton___SoP9s"};